import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { OrderTemplatesFacade } from 'src/app/extensions/order-templates/facades/order-templates.facade';
import { OrderTemplate } from 'src/app/extensions/order-templates/models/order-template/order-template.model';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { HttpError } from 'ish-core/models/http-error/http-error.model';

@Component({
  selector: 'custom-quickorder-page',
  templateUrl: './custom-quickorder-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomQuickorderPageComponent implements OnInit {
  loading$: Observable<boolean>;
  /**
   * The list of order templates of the customer.
   */
  orderTemplates$: Observable<OrderTemplate[]>;
  /**
   * Indicator for loading state of order templates
   */
  orderTemplateLoading$: Observable<boolean>;
  /**
   * Error state in case of an error during creation of a new order template.
   */
  orderTemplateError$: Observable<HttpError>;
  isLoggedIn$: Observable<boolean>;
  ordertemplates: OrderTemplate[];
  constructor(
    private checkoutFacade: CheckoutFacade,
    private orderTemplatesFacade: OrderTemplatesFacade,
    private accountFacade: AccountFacade
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.accountFacade.isLoggedIn$;
    this.loading$ = this.checkoutFacade.basketLoading$;
    this.orderTemplates$ = this.orderTemplatesFacade.orderTemplates$;
    this.orderTemplates$ = this.orderTemplates$
      .pipe(map(response => response.sort(this.compareFn)))
      .pipe(map(response => response.slice(0, 3)));
    this.orderTemplateLoading$ = this.orderTemplatesFacade.orderTemplateLoading$;
    this.orderTemplateError$ = this.orderTemplatesFacade.orderTemplateError$;
  }
  compareFn = (a: any, b: any) => {
    if (b.creationDate < a.creationDate) {
      return -1;
    }
    if (a.creationDate > a.creationDate) {
      return 1;
    }
    return 0;
  };
}
